(() => {
  if (customElements.get('pb26-product-gallery')) return;

  class PoolsideProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      this.thumbnails = [...this.querySelectorAll('[data-gallery-index]')];
      this.thumbnailTray = this.querySelector('[data-gallery-thumbnails]');
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.current = 0;
      this.trackWidth = this.track.clientWidth;
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.goTo(this.current - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.current + 1), options);
      this.thumbnails.forEach((button, index) => {
        button.addEventListener('click', () => this.goTo(index), options);
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          this.update(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)));
        });
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const destinations = { ArrowLeft: this.current - 1, ArrowRight: this.current + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        this.goTo(destinations[event.key]);
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (!width || width === this.trackWidth) return;
        this.trackWidth = width;
        this.track.scrollTo({ left: this.current * width, behavior: 'instant' });
      });
      this.resizeObserver.observe(this.track);
      this.dataset.galleryReady = 'true';
      this.update(0);
    }

    goTo(index) {
      const destination = Math.max(0, Math.min(index, this.slides.length - 1));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: destination * this.track.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
    }

    update(index) {
      this.current = Math.max(0, Math.min(index, this.slides.length - 1));
      this.counter.textContent = `${this.current + 1} / ${this.slides.length}`;
      this.previous.disabled = this.current === 0;
      this.next.disabled = this.current === this.slides.length - 1;
      this.thumbnails.forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.current)));
      this.slides.forEach((slide, position) => {
        slide.inert = position !== this.current;
        slide.setAttribute('aria-hidden', String(position !== this.current));
      });
      const selected = this.thumbnails[this.current];
      const selectedBounds = selected.getBoundingClientRect();
      const trayBounds = this.thumbnailTray.getBoundingClientRect();
      if (selectedBounds.left < trayBounds.left || selectedBounds.right > trayBounds.right) {
        this.thumbnailTray.scrollTo({ left: this.thumbnailTray.scrollLeft + selectedBounds.left - trayBounds.left - (this.thumbnailTray.clientWidth - selected.offsetWidth) / 2, behavior: 'instant' });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.controller = null;
    }
  }

  customElements.define('pb26-product-gallery', PoolsideProductGallery);
})();
